import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { weblogU } from 'src/app/models/weblogU'; // مسیر را مطابق با ساختار پروژه خود تنظیم کنید

@Component({
  selector: 'app-post-detail',
  templateUrl: './post-detail.component.html',
  styleUrls: ['./post-detail.component.css'] // اضافه کردن فایل CSS جدید برای استایل وبلاگ
})
export class PostDetailComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);
  private router = inject(Router);

  baseUrl = environment.apiBaseUrl;

  post: weblogU | null = null;
  isLoading = true;
  error: string | null = null;

  // متغیر جدید برای کنترل نمایش خلاصه یا کامل توضیحات
  showFullDescription = false;
  // تعداد خطوطی که در حالت خلاصه نمایش داده می‌شود (تقریبی)
  summaryLineLimit = 10;

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const postIdString = params.get('id');
      if (postIdString) {
        const postId = parseInt(postIdString, 10);
        if (!isNaN(postId)) {
          this.fetchPostDetails(postId);
        } else {
          this.error = 'شناسه پست نامعتبر است.';
          this.isLoading = false;
          console.error('Invalid post ID format received:', postIdString);
        }
      } else {
        this.error = 'شناسه پست یافت نشد.';
        this.isLoading = false;
        console.error('Post ID not found in route parameters.');
      }
    });
  }

  fetchPostDetails(id: number): void {
    this.isLoading = true;
    this.error = null;
    this.http.get<weblogU>(`${this.baseUrl}/weblog/${id}`).subscribe({
      next: (response) => {
        this.post = response;
        this.isLoading = false;
        // console.log('Post details fetched successfully:', this.post);
        // پس از دریافت داده، وضعیت showFullDescription را بر اساس نیاز تنظیم می‌کنیم
        // اگر توضیحات کوتاه باشد، نیازی به دکمه "ادامه مطلب" نیست و مستقیماً کامل نمایش داده می‌شود
        // اما برای سادگی، فعلاً همیشه روی false تنظیم می‌کنیم تا دکمه نمایش داده شود
        this.showFullDescription = false;
      },
      error: (err) => {
        console.error('Error fetching post details:', err);
        this.error = 'خطا در بارگذاری جزئیات پست.';
        if (err.status === 404) {
          this.error = 'پست مورد نظر یافت نشد.';
        } else if (err.status === 0) {
          this.error = 'خطا در اتصال به سرور. لطفاً اتصال اینترنت خود را بررسی کنید.';
        }
        this.isLoading = false;
      }
    });
  }

  goBackToList(): void {
    this.router.navigate(['/weblog']);
  }

  // تابعی برای تغییر وضعیت نمایش توضیحات
  toggleDescription(): void {
    this.showFullDescription = !this.showFullDescription;
  }

  // تابعی برای دریافت بخشی از توضیحات (خلاصه)
  getShortDescription(): string {
    if (!this.post || !this.post.description) {
      return '';
    }
    // این منطق برای تقسیم‌بندی بر اساس خطوط تقریبی است.
    // در عمل، شاید بهتر باشد از تعداد کاراکتر یا کلمه محدودیت بگذاریم.
    const lines = this.post.description.split('\n');
    return lines.slice(0, this.summaryLineLimit).join('\n');
  }

  // تابعی برای بررسی اینکه آیا توضیحات نیاز به دکمه "ادامه مطلب" دارد یا خیر
  needsMoreInfoButton(): boolean {
    if (!this.post || !this.post.description) {
      return false;
    }
    const lines = this.post.description.split('\n');
    // اگر تعداد خطوط بیشتر از حد مجاز باشد، دکمه لازم است
    return lines.length > this.summaryLineLimit;
  }
}
